export const EMAIL_REGEX = /\S+@\S+\.\S+/;

// Password must be at least 8 characters long and include:
// - at least one letter
// - at least one number
// - at least one special character (! @ # $ % ^ & * ( ) _ - + = [ ] { } | \ : ; " ' < > , . ? / ~ `)
// Only letters, numbers, and these special characters are allowed
export const PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=[\]{}|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()_\-+=[\]{}|\\:;"'<>,.?/~`]{8,}$/;

export const PHONE_REGEX = /^[+][0-9]{3}[0-9]{3}[0-9]{4,6}$/;
export const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

export const INTEGER_REGEX = /^(0|[1-9]\d*)$/;
export const FLOAT_REGEX = /^(0([.,]\d*)?$|[1-9]\d*([.,]\d*)?)$/;

export const LOCALE_REGEX = /^\/([a-z]{2})\//;
